import { createReducer } from '@reduxjs/toolkit';

import {
  resetApplicationState,
  setApplicationState, toggleRelatedArticleListingModal,
} from '../../actions/application/application';
import { profileNavigationTabs, userProfileNavigationTabs } from '../../common/profileNavigationTabs';
import { coOrderedPartsTable } from '../../constants/coOrderedPartsTable';
import { coWarehouseTable } from '../../constants/coWarehouseTable';
import { coOrdersTable } from '../../constants/coOrdersTable';
import { coAcceptanceTable } from '../../constants/coAcceptanceTable';

const initialState = {
  sidebarVisibility: localStorage.getItem('sidebarVisibility') !== 'false',
  isCoOrderHeaderFixed: localStorage.getItem('isCoOrderHeaderFixed') !== 'false',
  sidebarActiveMenu: undefined,
  profileActiveTab: profileNavigationTabs[0].type,
  userProfileActiveTab: userProfileNavigationTabs[1].type,
  selectedRow: [],
  otherUserSelectedRow: [],
  orderedPartsTableSetting: coOrderedPartsTable.map(({ source }) => source),
  warehouseTableSetting: coWarehouseTable.map(({ source }) => source),
  coOrderTableSetting: coOrdersTable.map(({ source }) => source) || [],
  coAcceptanceTableSetting: coAcceptanceTable.map(({ source }) => source) || [],
  relatedArticleListingModal: false
};

const applicationReducer = createReducer(initialState, {
  [setApplicationState]: (state, { payload }) => {
    const normalizedPayload = { ...payload };
    if ('selectedRow' in normalizedPayload && !Array.isArray(normalizedPayload.selectedRow)) {
      normalizedPayload.selectedRow = [];
    }
    if ('otherUserSelectedRow' in normalizedPayload && !Array.isArray(normalizedPayload.otherUserSelectedRow)) {
      normalizedPayload.otherUserSelectedRow = [];
    }

    return {
      ...state,
      ...normalizedPayload
    };
  },
  [toggleRelatedArticleListingModal]: (state) => ({
    ...state,
    relatedArticleListingModal: !state?.relatedArticleListingModal
  }),
  [resetApplicationState]: () => initialState
});

export default applicationReducer;
